<template>
    <hts-modal
        :show="visible"
        :title="'Từ chối booking ' + (bookingData.bookingNumber || '')"
        @hide="close">
        <div class="p-4">
            <p class="text-gray-700 mb-4">
                Bạn có chắc chắn muốn từ chối booking
                <span class="font-semibold">
                    {{ bookingData.bookingNumber }}
                </span>?
            </p>

            <div class="mb-4">
                <hts-form-select
                    v-model="reason"
                    :items="rejectReasons"
                    label="Lý do từ chối"
                    placeholder="Chọn lý do từ chối"
                    required />
            </div>

            <div v-if="reason === 'other'">
                <hts-form-textarea
                    v-model="reasonOther"
                    label="Lý do khác"
                    placeholder="Vui lòng nhập lý do từ chối booking"
                    required />
            </div>
        </div>

        <template #custom>
            <div class="flex justify-end space-x-3">
                <hts-form-button
                    color="gray"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
                <hts-form-button
                    color="error"
                    :loading="isSubmitting"
                    :disabled="!isValidForm"
                    @click="handleReject">
                    Xác nhận từ chối
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const visible = ref(false)
const bookingData = ref<any>({})
const reason = ref('')
const reasonOther = ref('')
const isSubmitting = ref(false)

const rejectReasons = [
  { label: 'Không có xe phù hợp', value: 'no_suitable_vehicle' },
  { label: 'Không có tài xế', value: 'no_driver' },
  { label: 'Lịch trình không phù hợp', value: 'schedule_conflict' },
  { label: 'Giá cả không phù hợp', value: 'price_issue' },
  { label: 'Khoảng cách quá xa', value: 'distance_too_far' },
  { label: 'Lý do khác', value: 'other' }
]

const isValidForm = computed(() => {
  if (!reason.value) {
    return false
  }
  if (reason.value === 'other' && !reasonOther.value) {
    return false
  }
  return true
})

const open = (data: any) => {
  bookingData.value = data
  reason.value = ''
  reasonOther.value = ''
  visible.value = true
}

const close = () => {
  visible.value = false
}

const handleReject = async () => {
  if (!isValidForm.value) {
    process.client && $toast().error('Vui lòng chọn lý do từ chối booking')
    return
  }

  isSubmitting.value = true

  try {
    const reasonText = reason.value === 'other' ? reasonOther.value : rejectReasons.find((r) => r.value === reason.value)?.label || ''

    const api = {
      url: '/marketplace/booking/reject',
      method: 'post'
    }

    // API để từ chối booking
    const response = await $api(api, {
      body: {
        id: bookingData.value._id,
        reason: reason.value,
        reasonText
      }
    })

    const resData = response?.data?.value

    if (resData?.success) {
      process.client && $toast().success('Từ chối booking thành công')
      close()
      emits('refresh-table')
    }
    isSubmitting.value = false
  } catch (error) {
    isSubmitting.value = false
  }
}

const emits = defineEmits(['refresh-table'])

defineExpose({
  open,
  close
})
</script>
